var $ = require('jquery');
$(".block-type--image").each(function() {

    // add floating class to parent wrapper if image is meant to be floated
    if ( $(this).find('.wp-block-image').hasClass('alignright') ) {
        $(this).addClass('alignright clearfix');
    } else if (  $(this).find('.wp-block-image').hasClass('alignleft') ) {
        $(this).addClass('alignleft clearfix');
    }

    // if its previous item is a paragraph AND this image is floated, add it to the previous element for it to float correctly.
    if ( $(this).prev().length 
         && $(this).prev().hasClass('block-type--paragraph') 
         && ( $(this).hasClass("alignright") || $(this).hasClass('alignleft') ) 
        ) {
        $(this).appendTo($(this).prev().find(".container-sm"));
    }
})

// $('.cover').each(function() {
//     $(this).find('.wp-block-cover__image-background').wrap('<div class="wp-block-cover__image-aspect-ratio">');
// })